// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Error503Page_wrapper__2ASaj","content":"Error503Page_content__NOVFj"};